import type { HelpFile } from '../../types/help'
import { PartyDetailTestIds } from '../../../testids/PartyDetailTestIds'

export const partyDetailHelp: HelpFile = {
  docPage: '/docs/identity/parties',
  texts: {
    [PartyDetailTestIds.partyDetailPage]:
      'Detail page for a party — a real-world actor such as a person, organisation, or AI agent — showing attributes, identities, hierarchy, and relationships.',
    [PartyDetailTestIds.sectionAttributes]:
      'Attribute values for this party, populated from attribute definitions configured for the party type.',
    [PartyDetailTestIds.sectionIdentities]:
      'Digital identities owned by this party — each represents the party in a specific context such as workforce or customer.',
    [PartyDetailTestIds.sectionPartyHierarchy]:
      'Organisational hierarchy — ancestors, immediate parent, and direct child parties.',
    [PartyDetailTestIds.sectionRelationships]:
      'Relationships to other parties — manager, mentor, and custom relationship types.',
    [PartyDetailTestIds.btnToggleOrgTree]:
      'Show or hide the organisational tree for this party.',
    [PartyDetailTestIds.colType]: null,
    [PartyDetailTestIds.colCreatedAt]: null,
    [PartyDetailTestIds.colLifecycleState]:
      'Current lifecycle phase of the related entity.',
    [PartyDetailTestIds.btnAddRelationshipPrefix()]:
      'Add a counterpart party to this relationship section. Disabled when the section has reached its maximum number of relationships.',
    [PartyDetailTestIds.btnRemoveRelationshipPrefix()]:
      'End this relationship — the row stays in the audit history with its end date set, but is no longer active.',
    [PartyDetailTestIds.dialogAddRelationshipPrefix()]:
      'Pick a counterpart party of the type allowed by the schema entry, then confirm to create the relationship.',
    [PartyDetailTestIds.dialogRemoveRelationshipPrefix()]:
      'Confirm that the relationship should be ended. Cancel keeps the row active; Confirm sets the end date.',
    [PartyDetailTestIds.comboboxAddRelationshipPrefix()]:
      'Type to filter parties of the counterpart party type allowed by this relationship section.',
    [PartyDetailTestIds.btnConfirmAddRelationshipPrefix()]:
      'Create the relationship to the selected counterpart party.',
    [PartyDetailTestIds.btnCancelAddRelationshipPrefix()]:
      'Close the picker without creating a relationship.',
    [PartyDetailTestIds.btnConfirmRemoveRelationshipPrefix()]:
      'End the relationship — the row is no longer active but stays in the audit history.',
    [PartyDetailTestIds.btnCancelRemoveRelationshipPrefix()]:
      'Close the dialog without ending the relationship.',
  },
}
